import type ScheduleBoardTemporaryEmployeeVM from 'ab-viewModels/scheduleBoardTemporaryEmployee.viewModel';

export const getDisplayData = (employee: ScheduleBoardTemporaryEmployeeVM) => {
	const { firstName: _firstName, lastName, duplicateDisplayNameExists } = employee;
	return {
		firstName: _firstName && (duplicateDisplayNameExists ? _firstName.slice(0, 2) : _firstName[0]),
		lastName,
	};
};
